(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/constants.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/constants.js');

'use strict';

const CONSTANTS = {
  DRAW_TYPE: {
    REGULAR: 1,
    CAMPAIGN: 3,
    PERIODIC: 4 
  },
  DRAW_STATE: {
    DEFINED: 1,
    OPEN: 2,
    REG_CLOSED: 3,
    CANCEL_CLOSED: 4,
    FINALIZED: 20
  }
};
if (svs.isServer) {
  module.exports = CONSTANTS;
} else {
  svs.numbergames.campaign.CONSTANTS = CONSTANTS;
}

 })(window);